import React from "react";
import { Link } from "react-router-dom";

function WorkProcessSection({ data, workProcess }) {
  const pageData = data || {};
  const processData = workProcess || [];

  const defaultProcess = [
    {
      id: 1,
      step_number: 1,
      title: "Նախնական զրույց",
      description:
        "Առաջին հանդիպման ընթացքում հասկանում ենք Ձեր կարիքները, նպատակները և խնդիրները՝ ապահովելով արդյունավետ համագործակցության համար անհրաժեշտ հստակ պատկերացում։",
    },
    {
      id: 2,
      step_number: 2,
      title: "Գործի վերլուծություն",
      description:
        "Մեր մասնագետները մանրամասն ուսումնասիրում են իրավիճակը, վերլուծում իրավական հիմքերը և կազմում լավագույն հնարավոր ռազմավարությունը․ արագ, ճշգրիտ և պրոֆեսիոնալ։",
    },
    {
      id: 3,
      step_number: 3,
      title: "Բյուջետավորում",
      description:
        "Ներկայացնում ենք հստակ և կանխատեսելի ծախսերի համադրություն՝ ապահովելով թափանցիկ ֆինանսական մոտեցում և առանց անակնկալների համագործակցություն։",
    },
    {
      id: 4,
      step_number: 4,
      title: "Իրականացում",
      description:
        "Մեր թիմը իրականացնում է համաձայնեցված քայլերը՝ ապահովելով որակ, ժամանակին կատարում և կոնկրետ արդյունքներ։ Մենք մշտապես կապի մեջ ենք՝ տեղեկացնելու առաջընթացի մասին։",
    },
  ];

  const processes = processData.length > 0 ? processData : defaultProcess;

  return (
    <div>
      <section className="work-process-section bg-dark">
        <div className="divider"></div>

        <div className="container">
          <div className="row g-5">
            <div className="col-12 col-md-5 col-xl-6">
              <div className="section-heading">
                <div className="sub-title text-white">
                  <img src="assets/img/core-img/hammer.png" alt="" />
                </div>

                <h2 className="mb-5 text-white">
                  {pageData.work_process_title ||
                    "Մեր ձևավորված և արդյունավետ աշխատանքային գործընթացը՝ հարմարեցված յուրաքանչյուր հաճախորդի"}
                </h2>
              </div>
            </div>

            <div className="col-md-7 col-xl-6">
              <div className="work-process">
                {processes.map((process, index) => (
                  <div
                    key={process.id}
                    className="process-card wow fadeInUp"
                    data-wow-duration="1000ms"
                    data-wow-delay={`${600 + index * 200}ms`}
                  >
                    <div className="number">{process.step_number}</div>

                    <div className="process-text">
                      <div className="process-title">{process.title}</div>
                      <p className="mb-0">{process.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>

        <div className="divider"></div>
      </section>
    </div>
  );
}

export default WorkProcessSection;
